<template>
  <a-layout id="components-layout-demo-top-side-2">
    <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%',padding: '0 30px', }" class="nav-bg">
      <my-header></my-header>
    </a-layout-header>
    <a-layout class="admin-main-warp">
      <a-layout-sider v-model="collapsed" collapsible theme="dark">
        <my-nav></my-nav>
      </a-layout-sider>
      <a-layout style="padding:24px">
        <a-tabs v-model="activeKey" hide-add type="editable-card" @edit="onEdit" @change="tabChange">
          <a-tab-pane v-for="pane in panes" :key="pane.key" :tab="pane.title"></a-tab-pane>
        </a-tabs>
        <a-layout-content
          :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px',flex:1,overflow:'auto' }"
        >
          <my-view></my-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import MyView from './myView'
import MyHeader from './template/myHeader'
import MyNav from './template/myNav'

export default {
  data() {
    return {
      collapsed: false,
      panes:[],
      activeKey: ''
    };
  },
  components: {
    MyView,
    MyHeader,
    MyNav
  },
  watch:{
    $route(){
      this.addPane();
    }
  },
  mounted () {
    this.addPane();
  },
  methods: {
    onEdit(targetKey, action) {
      this[action](targetKey);
      this.tabChange(this.activeKey)
    },
    addPane() {
      if(this.getStrCount(this.$route.path,'/')>=3){
        this.activeKey = this.$route.fullPath;
        for(var i=0;i<this.panes.length;i++){
          if(this.panes[i].key==this.$route.fullPath){
            break;
          }
        }
        var pathObj=this.forRouter(this.$router.options.routes[4].children,this.$route.path);
        if(pathObj!=''){
          if(i==this.panes.length&&pathObj.children.length==0){
            this.panes.push({
              title: this.$route.name,
              key: this.$route.fullPath,
            });
          }
        }
      }
    },
    forRouter(arr,path){
      var obj='';
      for(let i=0;i<arr.length;i++){
        if(path==arr[i].path){
          obj=arr[i]
          break;
        }else{
          if(arr[i].children.length>0){
            obj=this.forRouter(arr[i].children,path)
            if(obj!=''){
              break;
            }
          }
        }
      }
      return obj;
    },
    tabChange(activeKey){
      this.$router.push(activeKey)
    },
    remove(targetKey) {
      let activeKey = this.activeKey;
      let lastIndex;
      this.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1;
        }
      });
      if(this.panes.length>1){
        const panes = this.panes.filter(pane => pane.key !== targetKey);
        if (panes.length && activeKey === targetKey) {
          if (lastIndex >= 0) {
            activeKey = panes[lastIndex].key;
          } else {
            activeKey = panes[0].key;
          }
        }
        this.panes = panes;
        this.activeKey = activeKey;
      }
    },
  }

}
</script>

<style>
.admin-main-warp{
  height: calc(100vh - 64px);
  margin-top: 64px;
}
.ant-tabs-bar{
  margin: 0;
}
</style>
